import { EventEmitter } from '@angular/core';
import { QuestionnaireService } from './questionnaireService';
import { ApiService } from '../api.service';
import { CommonService } from '../common.service';
var AppQuestionnaireComponent = (function () {
    function AppQuestionnaireComponent(apiService, commonService) {
        this.apiService = apiService;
        this.commonService = commonService;
        this.onExit = new EventEmitter(); //关闭问卷
        this.questionnaireTitle = ""; //问卷标题
        this.questionnaireScoreArray = []; //问卷评级数组
        this.questionnaireTagArray = []; //问卷标签数组
        this.questionnaireLevel = 0; //问卷等级
        this.questionnaireHeadPhotoUrlArray = []; //问卷头像数组
        this.questionnaireContext = ""; //调查问卷内容
        this.selectedTag = ""; //用户选择的标签
        this.placeholder = ""; //textarea的placeholder
        this.postData = {}; //传递的数据
        this.isOpenMessage = false; //是否弹出提示
        this.isDisabled = false; //是否置灰
        this.tipMessage = ""; //提示内容
        this.buttonTheme = {
            'position': 'bottom',
            'fontSize': 'fontSize15',
            'buttonElem': [
                {
                    'color': 'blue',
                    'text': '提交反馈',
                    'className': 'inlineBlockRadiusBtn'
                },
                {
                    'color': 'cancel',
                    'text': '残忍拒绝',
                    'className': 'inlineBlockRadiusBtn'
                }
            ]
        }; //按钮主题
    }
    AppQuestionnaireComponent.prototype.ngOnInit = function () {
        this.questionnaireService = new QuestionnaireService(this.apiService);
        this.commonService.removeStorage("inputContext");
        // 初始化问卷
        this.questionnaireOnInit();
    };
    AppQuestionnaireComponent.prototype.ngAfterViewInit = function () {
    };
    // 初始化问卷
    AppQuestionnaireComponent.prototype.questionnaireOnInit = function () {
        var _this = this;
        this.questionnaireService.getQuestionnaireContent().subscribe(function (result) {
            _this.questionnaireTitle = _this.getQuestionnaireTitle(result);
            _this.questionnaireScoreArray = _this.getQuestionnaireScoreArray(result);
            _this.questionnaireTagArray = _this.getQuestionnaireTag(result);
            _this.questionnaireHeadPhotoUrlArray = _this.getQuestionnaireHeadPhotoUrl(result);
            _this.placeholder = _this.questionnaireDataFormatting(result, 2)[0].description;
        });
    };
    // 满意度数据分类格式化
    AppQuestionnaireComponent.prototype.questionnaireDataFormatting = function (questionnaire, type) {
        return questionnaire.filter(function (a) { return a.type == type; });
    };
    // 获取问卷标题
    AppQuestionnaireComponent.prototype.getQuestionnaireTitle = function (questionnaire) {
        return this.questionnaireDataFormatting(questionnaire, 1)[0].description;
    };
    //获取问卷评级
    AppQuestionnaireComponent.prototype.getQuestionnaireScoreArray = function (questionnaire) {
        return this.questionnaireDataFormatting(questionnaire, 2).filter(function (d) { return d.level !== 0; });
    };
    // 获取问卷头像
    AppQuestionnaireComponent.prototype.getQuestionnaireHeadPhotoUrl = function (questionnaire) {
        return this.questionnaireDataFormatting(questionnaire, 4);
    };
    //获取打分模块回传的等级
    AppQuestionnaireComponent.prototype.getQuestionnaireLevel = function (data) {
        this.questionnaireLevel = data + 1;
        this.placeholder = this.questionnaireScoreArray[this.questionnaireLevel - 1].description;
    };
    //获取问卷标签
    AppQuestionnaireComponent.prototype.getQuestionnaireTag = function (questionnaire) {
        return this.questionnaireDataFormatting(questionnaire, 3);
    };
    // 获取回传的标签
    AppQuestionnaireComponent.prototype.getSelectedTag = function (data) {
        this.selectedTag = data;
    };
    //获取调查问卷内容
    AppQuestionnaireComponent.prototype.getQuestionnaireContext = function (data) {
        this.questionnaireContext = data;
    };
    //打开提示
    AppQuestionnaireComponent.prototype.openMessageBox = function () {
        var _this = this;
        this.isOpenMessage = true;
        setTimeout(function () {
            _this.isOpenMessage = false;
        }, 1500);
    };
    //提交反馈
    AppQuestionnaireComponent.prototype.commitQuestionnaire = function () {
        var _this = this;
        if (this.questionnaireLevel === 0) {
            this.tipMessage = "请对英跃进行评分";
            this.openMessageBox();
        }
        else {
            this.isDisabled = true;
            this.postData['learningPathMetaId'] = this.learningPathMetaId;
            this.postData['star'] = this.questionnaireLevel;
            this.postData['context'] = this.questionnaireContext;
            if (this.enter === 1) {
                this.postData['isShow'] = 1;
            }
            console.log(this.questionnaireContext);
            // 如果用户网络在线提交反馈，否则弹出提示并关闭问卷
            if (window.navigator.onLine) {
                this.questionnaireService.saveUserQuestionnaireInfo(this.postData).then(function (result) {
                    if (result) {
                        _this.tipMessage = "谢谢你的反馈！";
                        _this.openMessageBox();
                        _this.onExit.emit();
                    }
                }).catch(function (error) {
                    _this.tipMessage = error.error.msg;
                    _this.openMessageBox();
                    setTimeout(function () {
                        _this.onExit.emit();
                    }, 2000);
                });
            }
            else {
                this.tipMessage = "网络不稳定，阻碍了提交的脚步。可以稍后再试一次吗？";
                this.openMessageBox();
                setTimeout(function () {
                    _this.onExit.emit();
                }, 2000);
            }
        }
    };
    //残忍拒绝
    AppQuestionnaireComponent.prototype.closeQuestionnaire = function () {
        this.postData['learningPathMetaId'] = this.learningPathMetaId;
        this.postData['star'] = -1;
        this.postData['context'] = null;
        if (this.enter === 1) {
            this.postData['isShow'] = 1;
        }
        this.questionnaireService.saveUserQuestionnaireInfo(this.postData);
        this.onExit.emit();
    };
    return AppQuestionnaireComponent;
}());
export { AppQuestionnaireComponent };



// WEBPACK FOOTER //
// ./src/app/app-questionnaire/app-questionnaire.component.ts.pre-build-optimizer.js